module.exports = __webpack_public_path__ + "img/dict.e54d50d6.svg";